/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createFieldMappingRequestSchema = z.object({
  mapName: z.string().min(1),
  sourceFieldId: z.string().nullish(),
  sourceFieldName: z.string().min(1),
  sourceFieldType: z.enum([
    'SELECT',
    'MULTI_SELECT',
    'DATE',
    'DATETIME',
    'TEXT',
    'MULTILINE_TEXT',
    'NUMERIC',
    'CHECKBOX',
    'MULTI_CHECKBOX',
    'USER',
    'MULTI_USER',
    'TEAM',
    'VERSION',
    'COMPONENT',
    'LABELS',
  ]),
  tempoFieldId: z.int(),
  tempoFieldName: z.string().min(1),
  tempoFieldType: z.enum([
    'CHECKBOX',
    'CURRENCY',
    'DATE',
    'ITEM',
    'LINK',
    'MULTI_CUSTOMER',
    'MULTI_ITEM',
    'MULTI_LINK',
    'MULTI_PICKLIST',
    'MULTI_TEXT',
    'MULTI_USER',
    'MULTILINE_TEXT',
    'NOTE',
    'NUMERIC',
    'PICKLIST',
    'TEXT',
    'USER',
  ]),
});
